const PreTable = () => {
    return (
        <div className="row">
            <div className="col-12">
                <h6 className="title-6">Accesos Portales B2B</h6>
                <span className="text">Completa la tabla con la información solicitada.
                <b> Puedes agregar las cadenas de la lista que desees.</b></span>
                <br />
            </div>
        </div>
    );
};

export default PreTable;
